import * as loanEstimateAPI from 'login-apis/loanEstimateAPI';
import { hashHistory } from 'react-router';
import { CreationParams } from 'login-utils/stateUtils';
import { SubmissionError } from 'redux-form';
import States from 'login-constants/states';
import * as _ from 'lodash';
import store from 'login-store';
import * as onboardingForm from 'login-utils/onboardingForm';
import { utils } from 'ui-common';
const { featureFlags } = utils;

/**
 * ReduxForm doesn't play nicely with being submit not in the context of the Field element itself,
 * so in order to append values to the submit object here, we're using a higher order function that
 * passes the initial values in and then returns a function to be submit in the context ReduxForm while
 * retaining access to the initial values through the closure.
 *
 * See a related discussion here: https://github.com/erikras/redux-form/issues/1297
 */

export const submitEstimate = (optionalParams: CreationParams) =>
  async function submitEstimateInner(values) {
    let completeValueSet: LoanEstimate;
    if (featureFlags.isEnabled('exportLoanTypeWithLoanEstimate20190313')) {
      const state = store.getState() as ReduxState;
      const loanType: LoanType = onboardingForm.getLoanType(state);
      completeValueSet = _.extend({}, values, optionalParams, { loanType });
    } else {
      completeValueSet = _.extend({}, values, optionalParams);
    }

    try {
      await loanEstimateAPI.submit(completeValueSet);
      hashHistory.push(States.LOAN_ESTIMATE_RECEIVED);
    } catch (err) {
      const defaultError = 'There was an error submitting the form.';
      throw new SubmissionError({ _error: _.get(err, 'response.data', defaultError) });
    }
  };
